/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResendOrgInviteResponse } from '../../models/resend-org-invite-response';

export interface ResendOrgInvite$Params {

/**
 * ID of the user to resend the invite to
 */
  userId: string;

/**
 * ID of the organization the user belongs to
 */
  orgId: string;
  
    /**
     * Empty body.
     */
    body?: {
}
}

export function resendOrgInvite(http: HttpClient, rootUrl: string, params: ResendOrgInvite$Params, context?: HttpContext): Observable<StrictHttpResponse<ResendOrgInviteResponse>> {
  const rb = new RequestBuilder(rootUrl, resendOrgInvite.PATH, 'post');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.path('orgId', params.orgId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResendOrgInviteResponse>;
    })
  );
}

resendOrgInvite.PATH = '/api/v2/{userId}/organization/{orgId}/resendInvite';
